export type AppNameState = 'TelePagos' | 'YellowCash' | 'FunesApp' | 'PymeRural';

export const initialState : AppNameState | null = null;
